import { render } from "./Competitors.vue?vue&type=template&id=34c449e8"
import script from "./Competitors.vue?vue&type=script&lang=ts"
export * from "./Competitors.vue?vue&type=script&lang=ts"
script.render = render

export default script